/**
 * ACCORDION STANDALONE MODULE
 */

export namespace StandardNav {
	/**
	 * Function intializes all Accordion Modules
	 * @constructor
	 */
	let SetupStandardNav = () => {
        let standardNavs = document.querySelectorAll<HTMLElement>('.js-standard-nav');
        if(!standardNavs.length) {
        	return;
        }
		standardNavs.forEach((standardNav, index) => {
			let standardNavLinks = standardNav.querySelectorAll(".standard-nav__link");
			let standardNavMobileTrigger = standardNav.querySelector('.js-standard-nav-trigger');

			standardNavLinks.forEach((link) => {
				let linkHref = link.getAttribute('href');
				let linkText = link.textContent;

				if(window.location.href.indexOf(linkHref) !== -1) {
					link.parentElement.classList.add('state-active');
					standardNavMobileTrigger.textContent = linkText;
				} else {
					link.parentElement.classList.remove('state-active');
				}
			});

			standardNavMobileTrigger.addEventListener('click', (e) => {
				e.preventDefault();
				if(standardNav.classList.contains('state-open')) {
					standardNav.classList.remove('state-open');
				} else {
					standardNav.classList.add('state-open');
				}
			});
        });
    }


	/**
	 * Initialize our Accordion Module
	 */
	export const init = () => {
		SetupStandardNav();
	}
}

/**
 * DOMContentLoaded may fire before script has a chance to run, so it is wise to check before adding
 */
if (document.readyState === 'loading') {  // Loading hasn't finished yet
	document.addEventListener('DOMContentLoaded', StandardNav.init);
} else {  // `DOMContentLoaded` has already fired
	StandardNav.init();
}
